import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Eyebrow } from "@/components/Reveal";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { Trash2 } from "lucide-react";

export const AdminHeader = ({ eyebrow, title, onAdd, addLabel = "Add New" }) => (
  <div className="flex items-end justify-between mb-8">
    <div>
      <Eyebrow>{eyebrow}</Eyebrow>
      <h1 className="font-display text-4xl font-medium text-[#2C2A29] mt-2">{title}</h1>
    </div>
    {onAdd && (
      <Button onClick={onAdd} className="rounded-none bg-[#2C2A29] hover:bg-[#4A4641] text-[#FFFFFF] h-11 px-6 label-eyebrow text-[10px]" data-testid="admin-add-button">
        <Plus size={16} className="mr-1" /> {addLabel}
      </Button>
    )}
  </div>
);

export const DeleteButton = ({ onConfirm, label = "this item", testid }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <button className="text-[#5E5A54] hover:text-red-700 transition-colors p-2" data-testid={testid} aria-label="Delete">
        <Trash2 size={16} />
      </button>
    </AlertDialogTrigger>
    <AlertDialogContent className="bg-[#FFFFFF] rounded-none border-[#ECEAE4]">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display text-2xl">Delete {label}?</AlertDialogTitle>
        <AlertDialogDescription>This action cannot be undone.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="rounded-none">Cancel</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className="rounded-none bg-red-700 hover:bg-red-800" data-testid="confirm-delete">Delete</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
